import { ASPECT_RATIO_TYPES } from 'constants/image.js';

export const { PORTRAIT, LANDSCAPE } = ASPECT_RATIO_TYPES;

export const DRAGGABLE_SIZES = {
  [PORTRAIT]: { width: 270, height: 480 },
  [LANDSCAPE]: { width: 480, height: 270 },
};

export const INITIAL_POSITION = {
  right: 20,
  bottom: 20,
};
